import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const StyledSelect = withStyles(({ typography }) => ({
  root: {
    backgroundColor: '#2D3238',
    minWidth: '148px',

    '&.expanded': {
      backgroundColor: '#464C54',
    },

    '&.expanded .MuiButton-endIcon': {
      transform: 'rotate(180deg)',
    },
  },
  label: {
    ...typography.body2,
    color: '#EDF0F4',
    fontWeight: 500,
    justifyContent: 'space-between',
  },
  endIcon: {
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
}))(Button);
